export const GET_JOBPROFILE_REQUEST = 'GET_JOBPROFILE_REQUEST';
export const GET_JOBPROFILE_SUCCESS = 'GET_JOBPROFILE_SUCCESS';
export const GET_JOBPROFILE_FAILURE = 'GET_JOBPROFILE_FAILURE';

export const UPDATE_JOBPROFILE_REQUEST = 'UPDATE_JOBPROFILE_REQUEST';
export const UPDATE_JOBPROFILE_SUCCESS = 'UPDATE_JOBPROFILE_SUCCESS';
export const UPDATE_JOBPROFILE_FAILURE = 'UPDATE_JOBPROFILE_FAILURE';